<template>
  <div class="updatePasswordModal">
    <div class="updatePasswordModal__wrapper container">
      <div class="updatePasswordModal__row row">
        <p class="updatePasswordModal__title col-md-4 col-md-offset-1">
          新密碼
        </p>
        <input
          class="updatePasswordModal__input col-md-6"
          type="text"
          v-model="password"
        />
      </div>
      <div class="updatePasswordModal__row row">
        <p class="updatePasswordModal__title col-md-4 col-md-offset-1">
          確認密碼
        </p>
        <input
          class="updatePasswordModal__input col-md-6"
          type="password"
          v-model="confirmedPassword"
        />
      </div>
      <div class="updatePasswordModal__row row">
        <BaseButton
          class="updatePasswordModal__button col-md-3 col-md-offset-2"
          :text="'確認'"
          @click="updatePassword"
        ></BaseButton>
        <BaseButton
          class="updatePasswordModal__button col-md-3 col-md-offset-2"
          :text="'取消'"
          :backgroundColor="'#67c16a'"
          @click="$emit('hideUpdatePasswordModal')"
        ></BaseButton>
      </div>
    </div>
  </div>
</template>
<script>
import BaseButton from '@/components/common/button/BaseButton'
import managerService from '@/API/managerService'

export default {
  name: 'UpdatePasswordModal',
  data() {
    return {
      password: '',
      confirmedPassword: '',
    }
  },
  methods: {
    async updatePassword() {
      if (this.checkPasswordEmpty() && this.checkPasswordConfirmed()) {
        await managerService
          .updatePassword(this.$route.params.id, { newPassword: this.password })
          .then(() => {
            alert('更新密碼成功')
            this.$emit('hideUpdatePasswordModal')
          })
          .catch((err) => alert(`更新密碼失敗 ${err}`))
      }
    },
    checkPasswordEmpty() {
      if (this.password === '') {
        alert('請輸入新密碼')
        return false
      }
      return true
    },
    checkPasswordConfirmed() {
      if (this.password !== this.confirmedPassword) {
        alert('確認密碼與新密碼不符')
        return false
      }
      return true
    },
  },
  components: {
    BaseButton,
  },
}
</script>
<style lang="scss" scoped>
.updatePasswordModal {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1050;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba($color: #000000, $alpha: 0.2);

  &__wrapper {
    width: 500px;
    padding: 30px;
    background: #ffffff;
    border: 10px solid #5f5f5f;
  }

  &__row {
    margin-bottom: 10px;
    &:last-child {
      margin-top: 20px;
      margin-bottom: 0;
    }
  }

  &__title {
    text-align: center;
    font-size: 16px;
    margin-bottom: 0;
    line-height: 36px;
  }

  &__input {
    padding: 6px 12px;
    font-size: 16px;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modal/UpdatePasswordModal.vue